import React from "react";
import { FloatingActionBarContainer } from "./FloatingActionBar.styled";
import { Portal, Slide } from "@mui/material";
import FloatingActionBarDescription from "./extensions/FloatingActionBarDescription";
import FloatingActionBarButton from "./extensions/FloatingActionBarButton";
import FloatingActionBarGrid from "./extensions/FloatingActionBarGrid";
import FloatingActionBarCloseButton from "./extensions/FloatingActionBarCloseButton";

const accessabilityProps = {
  role: "region",
  "aria-label": "Floating Action Bar",
} as const;

type CustomSlideProps = Omit<React.ComponentProps<typeof Slide>, "children">;

type FloatingActionBarProps = {
  bottom?: string;
  children?: React.ReactNode;
  slideProps?: CustomSlideProps;
};

function FloatingActionBar({
  bottom = "0",
  children,
  slideProps,
}: FloatingActionBarProps) {
  return (
    <Portal>
      <Slide
        appear={false}
        direction="up"
        unmountOnExit
        mountOnEnter
        easing="ease-in-out"
        {...slideProps}
      >
        <FloatingActionBarContainer
          bottom={bottom}
          elevation={3}
          {...accessabilityProps}
        >
          {children}
        </FloatingActionBarContainer>
      </Slide>
    </Portal>
  );
}

FloatingActionBar.Description = FloatingActionBarDescription;
FloatingActionBar.Button = FloatingActionBarButton;
FloatingActionBar.Grid = FloatingActionBarGrid;
FloatingActionBar.CloseButton = FloatingActionBarCloseButton;

export default FloatingActionBar;
